// browser-detection.service.ts
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class BrowserDetectionService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  getBrowserName(): string {
    if (isPlatformBrowser(this.platformId)) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.includes('chrome') && !userAgent.includes('edge')) {
        return 'chrome';
      } else if (userAgent.includes('firefox')) {
        return 'firefox';
      } else if (userAgent.includes('edge') || userAgent.includes('edg/')) {
        return 'edge';
      }
    }
    return 'unknown';
  }
}
